import { Component, OnInit, Output, EventEmitter, Input, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MarkCleanFormAction } from 'src/app/app-state/actions/dirty-form.actions';
import { ConfirmationModalComponent } from 'src/app/modules/shared/modal/confirmation-modal/confirmation-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { Store } from '@ngrx/store';
import { takeUntil } from 'rxjs/operators';
import moment from 'moment';
import { FreeTrialService } from '../free-trial.service';

@Component({
  selector: 'app-summary-info',
  templateUrl: './summary-info.component.html',
  styleUrls: ['./summary-info.component.scss']
})
export class SummaryInfoComponent implements OnInit {

  @Output() notify: EventEmitter<number> = new EventEmitter<number>();
  @Input() companyId;
  @Input() companyInfo;
  petitionerRoleList: [];
  summaryDisplayForm: FormGroup;
  listRoles: object[];
  listPermissions: object[];
  roleDataSource = [];
  uniqueListRoles = [];
  origColumns = [];
  displayedColumns: string[] = [];
  observableSubscription$ = new Subject();
  dirtyFlag: boolean = false;
  disableFields = false;
  getLink: any;
  companyData;
  listBene = [];
  planName: string;
  maxDate: Date;
  attorneyBeneInv: boolean = false;
  petitionerBeneInv: boolean = false;
   value: Date;
  getPlanStartDate: any;
  planDisabled: boolean = false;
  freeTrialPlan: boolean = false;
  myDate: any;
  agree: boolean = true;
  bearerToken: any;
  finalDate: any;
  firmAttorneyCompanyName: string;
  firmAttorneyFeiNo: string;
  constructor(
              protected store: Store<any>,
              public dialog: MatDialog,
              private router: Router,
              private toastr: ToastrService,
              private fb: FormBuilder,
              private freeTrialService: FreeTrialService,
              private route: ActivatedRoute)
               {
                  this.listRoles = [];
                  this.maxDate = new Date();
               }

  ngOnInit() {
    this.planName = localStorage.getItem('plan');
    if (localStorage.getItem('plan') === 'Petitioner Plan') {
      this.summaryDisplayForm = this.fb.group({
        companyName: [''],
        businessType: [''],
        incorporationLocation: [''],
        establishmentDate: [''],
        noOfEmployees: [''],
        naicsCode: [''],
        feiNumber: [''],
        othername: [''],
        petitionerRoleList: [''],
        userName: [''],
        email: [''],
        beneficiaryName: [''],
        beneficiaryUserID: [''],
        beneEmail: [''],
        listOfCreatedBeneficiaries: [''],
        listOfInvitedBeneficiaries : [''],
        listOfUser: [''],
        date: ['']
      });
    } else{
      this.summaryDisplayForm = this.fb.group({
        firmName: [''],
        feiNumberFirm: [''],
        userName: [''],
        email: [''],
        listOfInvitedBeneficiaries : [''],
        listOfUser: [''],
        companyName: [''],
        businessType: [''],
        incorporationLocation: [''],
        establishmentDate: [''],
        noOfEmployees: [''],
        naicsCode: [''],
        feiNumber: [''],
        petitionerRoleList: [''],
        beneficiaryName: [''],
        beneficiaryUserID: [''],
        beneEmail: [''],
        listOfCreatedBeneficiaries: [''],
        date: [''],
        companyNameClient: [''],
        companyNameClientEmail: [''],
        companyNameClientAddress: [''],
        companyNameClientMobile: [''],
        companyNameClientUserName: [''],
      });
    }
    if (localStorage.getItem('plan') === 'Petitioner Plan') {
      this.getReviewSummaryDetails();
      this.getReviewSummaryDetailsUser();
      this.getReviewSummaryDetailsbeneficiary();
    } else {
      this.getReviewSummaryFirmInfo();
      this.getReviewSummaryDetailsUser();
      this.getReviewSummaryDetailsbeneficiary();
      this.getClientCompanyFirmInfo();
    }
  }

  getReviewSummaryDetailsUser() {
    // let userData = this.freeTrialService.getuserInfo();
    let userData = this.freeTrialService.getUserInfoArray();
    console.log('userData :--' + JSON.stringify(userData));
    this.summaryDisplayForm.patchValue({
      userName: userData.firstName + " " + userData.lastName,
      role: "Petitioner Admin",
      email: userData.email,
      listOfUser: userData
    });
  }

  getReviewSummaryDetailsbeneficiary() {
    let beneficiaryData = this.freeTrialService.getBeneficiaryInfoArray();
  //  let beneficiaryDataArray = this.freeTrialService.beneficiaryInfoArray();
    this.summaryDisplayForm.patchValue({
      beneficiaryName: beneficiaryData.firstName + " " + beneficiaryData.lastName,
      beneficiaryUserID: beneficiaryData.userId,
      beneEmail: beneficiaryData.emailId,
      listOfInvitedBeneficiaries: beneficiaryData
    });
  }

  getPlanDate(event) {
    const someDate = new Date(Date.parse(event));
    const numberOfDaysToAdd = 15;
    this.getPlanStartDate = someDate.setDate(someDate.getDate() + numberOfDaysToAdd);
    this.planDisabled = true;
    this.freeTrialPlan = true;
    const event123 = new Date(this.getPlanStartDate);
    this.finalDate = event123.toISOString();
  }

  getClientCompanyFirmInfo() {
    let clientCompanyFirmInfo = this.freeTrialService.getCompanyClientFirmInfo();

   // let userCompanyFirmInfo = this.freeTrialService.getFirmUserInfoAttorney();
    let userCompanyFirmInfo = this.freeTrialService.getattorneyUserInfoArray();

    console.log('clientCompanyFirmInfo :--' + JSON.stringify(clientCompanyFirmInfo));
    console.log('userCompanyFirmInfo :--' + JSON.stringify(userCompanyFirmInfo));
    for (let attorneypetitioneruser of userCompanyFirmInfo) {
        this.summaryDisplayForm.patchValue({
      companyNameClient: clientCompanyFirmInfo.company.companyName,
      companyNameClientEmail: clientCompanyFirmInfo.company.emailContact.email,
      companyNameClientAddress: clientCompanyFirmInfo.company.address1,
      companyNameClientMobile: clientCompanyFirmInfo.company.mobileContacts,
      companyNameClientUserName: attorneypetitioneruser.firstName + ' ' + attorneypetitioneruser.lastName + ' ( Petitioner Admin ) ',
      businessType: clientCompanyFirmInfo.company.businessType,
      incorporationLocation: clientCompanyFirmInfo.company.incorporationLoc.countryCode,
      establishmentDate: moment(clientCompanyFirmInfo.company.establishedDate).format('MM-DD-YYYY'),
      noOfEmployees: clientCompanyFirmInfo.company.employeeCount,
      naicsCode: clientCompanyFirmInfo.company.naicsCode,
      feiNumber: clientCompanyFirmInfo.company.feiNo,
    });
  }
  }

  getReviewSummaryFirmInfo() {
    this.firmAttorneyCompanyName = localStorage.getItem("firmAttorneyCompanyName");
    this.firmAttorneyFeiNo = localStorage.getItem("firmAttorneyFeiNo");
    let firmData = this.freeTrialService.getFirmInfo();
    console.log('companyData :--' + JSON.stringify(firmData));
    this.summaryDisplayForm.patchValue({
      firmName: firmData.company.companyName,
      feiNumberFirm: firmData.company.feiNo,
  });

  }

  getReviewSummaryDetails(){
    let companyData = this.freeTrialService.getcompanyInfo();
    console.log('companyData :--' + JSON.stringify(companyData));

    for (let getBusinessType of companyData.company.businessType) {
      if( getBusinessType.name == 'Other' ) {
        companyData.company.businessType.splice(companyData.company.businessType.indexOf(getBusinessType), 1);
        break;
      }
    }

    this.summaryDisplayForm.patchValue({
      companyName: companyData.company.companyName,
      businessType: companyData.company.businessType,
      incorporationLocation: companyData.company.incorporationLoc.countryCode,
      establishmentDate: moment(companyData.company.establishedDate).format('MM-DD-YYYY'),
      noOfEmployees: companyData.company.employeeCount,
      naicsCode: companyData.company.naicsCode,
      feiNumber: companyData.company.feiNo,
      othername: companyData.company.othername
  });
}

  buildRoleList(permissions){
    permissions.forEach((v, k) => {
      let rowObj = {
        perm_name: v['description']
      }
      this.listRoles.forEach((val, key) => {
        rowObj[val['name']] = false;
        if (val['permissionList'].length > 0) {
          val['permissionList'].forEach(item => {
            if (item.id == v['id']) {
              rowObj[val['name']] = true;
            }
          })
        } else {
          rowObj[val['name']] = false;
        }
      });
      this.roleDataSource.push(rowObj);
    });
    return(this.roleDataSource);
  }

  onCancel(){
    if (this.dirtyFlag) {

      this.dialog.open(ConfirmationModalComponent, {
        width: '400px',
        data: {
          update: {
            title: 'Unsaved Changes!',
            message: 'Changes you made on this section is not saved yet. Do you wish to continue?'
          },
          // buttons: ['No, Stay on the Page', 'Yes, Leave the Page']
          buttons: ['No', 'Yes'],
          disableClose: true
        }
      }).afterClosed().subscribe(confirmed => {
        if (confirmed) {
          this.store.dispatch(new MarkCleanFormAction({ dirty: false }));
          this.dirtyFlag = false;
          this.router.navigate([`/login/login/signin`]);
        }
      });

    } else {
      this.router.navigate([`/login/login/signin`]);
    }

  }

  onPrevious(){
    if (localStorage.getItem("plan") == "Petitioner Plan") {
      this.notify.emit(2);
    } else {
      this.notify.emit(3);
    }
  }

  onSubmit() {

    this.route.queryParams.subscribe(params => {
      this.getLink = params['linkRequestCode'];
  });

    if (localStorage.getItem("plan") == 'Petitioner Plan') {

    let companyData = this.freeTrialService.getcompanyInfo();
    let petitionerUserEmployeeDTO = this.freeTrialService.getUserInfoArray();
    let listOfInvitedBeneficiarys = this.freeTrialService.getBeneficiaryInfoArray();

    const payload = {
        attorneyCreateDTO: null,
        attorneyUserEmployeeDTO: null,
        companyCreateDTO: {
          relationShip: {id: null},
          relatedCompany: null,
          company: {
            id: null,
            companyLogo: "",
            companyName: companyData.company.companyName,
            feiNo: companyData.company.feiNo,
            incorporationLoc: {
              countryCode: companyData.company.incorporationLoc.countryCode
            },
            companyType: {id: 38},
            emailContacts: [
              {
                type: {id: 34},
                email: companyData.company.emailContact.email
              },
              {
                type: {id: 35},
                email: companyData.company.altEmailContact.email
              }
            ],
            establishedDate: companyData.company.establishedDate ? moment(companyData.company.establishedDate).format('MM-DD-YYYY') : null,
            phoneContacts: [
              {
                id: null,
                countryCode: {
                  countryCode: companyData.company.mobileContacts.countryCode
                },
                phoneNo: companyData.company.mobileContacts.phoneNo,
                type: { id: 30 }
              },
              {
                id: null,
                countryCode: {
                  countryCode: companyData.company.phoneContactss.countryCode
                },
                phoneNo: companyData.company.phoneContactss.phoneNo,
                type: { id: 31 }
              }
            ],
            address: [
              {
                id: null,
                addressLine1: companyData.company.address1,
                city: companyData.company.city,
                countryCode: {countryCode: companyData.company.countryCodeAdd},
                postCode: companyData.company.postCode,
                stateProvinceCode: companyData.company.stateProvinceCode,
                type:
                {
                  id: 3,
                  code: "REGS"
                }
              },
              {
                id: null,
                addressLine1: companyData.company.address2,
                city: companyData.company.city,
                countryCode: {countryCode: companyData.company.countryCodeAdd},
                postCode: companyData.company.postCode,
                stateProvinceCode: companyData.company.stateProvinceCode,
                type:
                {
                  id: 5,
                  code: "MAIL"
                }
              }
              ],
            employeeCount: companyData.company.employeeCount,
            grossAnnualIncome: companyData.company.grossAnnualIncome,
            netAnnualIncome: companyData.company.netAnnualIncome,
            classification: "",
            mgrExecUSCount: "",
            mgrExecNonUSCount: "",
            naicsCode: companyData.company.naicsCode,
            dotCode: "",
            businessType:
            [
              {
                otherBusTypeName: companyData.company.businessType.name,
                typeId: {id: 37}
              },
            ]

          }
        },
        listOfInvitedBeneficiarys,
        petitionerUserEmployeeDTO,
        planStartDate: this.finalDate
  };
    console.log('payload :--' + JSON.stringify(payload));
    this.freeTrialService.postReviewSummaryPetitionerFlow(this.getLink, payload)
      .pipe(takeUntil(this.observableSubscription$))
      .subscribe((response: any) => {
        if (response.status == 200) {
          this.toastr.success(response.message, 'Success');
          localStorage.removeItem("plan");
          localStorage.removeItem("tokenFetch");
          localStorage.removeItem("companyname");
          this.router.navigate([`/`]);
        }
      });
    }  else {

      // payload for Attorney Flow
        let companyData = this.freeTrialService.getCompanyClientFirmInfo();
        console.log('companyDataFirmAttorney:--' + JSON.stringify(companyData));

        let companyFirmData = this.freeTrialService.getFirmInfo();
        console.log('companyFirmData:--' + JSON.stringify(companyFirmData));

        // Attorney user  attorneyUserEmployeeDTO
      //  let userData = this.freeTrialService.getuserInfo();
        let attorneyUserEmployeeDTO = this.freeTrialService.getUserInfoArray();
        console.log('userData:--' + JSON.stringify(attorneyUserEmployeeDTO));

        let listOfInvitedBeneficiarys = this.freeTrialService.getBeneficiaryInfoArray();
        console.log('listOfInvitedBeneficiarys:--' + JSON.stringify(listOfInvitedBeneficiarys));

        // attorney petitioner user  
       // let userCompanyFirmInfo = this.freeTrialService.getFirmUserInfoAttorney();
        let petitionerUserEmployeeDTO = this.freeTrialService.getattorneyUserInfoArray();
        console.log('petitionerUserEmployeeDTO:--' + JSON.stringify(petitionerUserEmployeeDTO));
        console.log('petitionerUserEmployeeDTO.length:--' + petitionerUserEmployeeDTO.length);
        if (petitionerUserEmployeeDTO.length === 0) {
          const payload = {
            attorneyCreateDTO: {
              relationShip: {
                id: null
               },
              relatedCompany: null,
              company: {
                id: null,
                companyLogo: "",
                companyName: companyFirmData.company.companyName,
                feiNo: companyFirmData.company.feiNo,
                establishedDate: companyFirmData.company.establishedDate,
                incorporationLoc: {
                  countryCode: companyFirmData.company.incorporationLoc
                },
                companyType: {id: 39},
                emailContacts: [
                  {
                    type: {
                      id: 34
                    },
                    email: companyFirmData.company.emailContact.email
                  }
                ],
                phoneContacts: [
                  {
                    id: null,
                    countryCode: {countryCode: "USA"},
                    phoneNo: "123456789",
                    type: { id: 30}
                  },
                ],
                address: [
                {
                  id: null,
                  addressLine1: companyFirmData.company.address1,
                  city: companyFirmData.company.city,
                  countryCode: {
                    countryCode: companyFirmData.company.countryCodeAdd
                  },
                  postCode: companyFirmData.company.postCode,
                  stateProvinceCode: companyFirmData.company.stateProvinceCode,
                  type: {
                    id: 3,
                    code: "REGS"
                    }
                }
              ],
                employeeCount: companyFirmData.company.employeeCount,
                grossAnnualIncome: companyFirmData.company.grossAnnualIncome,
                classification: "",
                netAnnualIncome: companyFirmData.company.netAnnualIncome,
                mgrExecUSCount: companyFirmData.company.mgrExecUSCount,
                mgrExecNonUSCount:companyFirmData.company.mgrExecNonUSCount,
                dotCode: "",
                naicsCode: companyFirmData.company.naicsCode,
                businessType: [
                  {
                    otherBusTypeName: null,
                    typeId: {id: 37}
                  }
                ]
                }
            },
            attorneyUserEmployeeDTO,
             companyCreateDTO: null,
             listOfInvitedBeneficiarys,
             petitionerUserEmployeeDTO: null,
             planStartDate: this.finalDate
       };
          console.log('payload :--' + JSON.stringify(payload));
          this.freeTrialService.postReviewSummaryPetitionerFlow(this.getLink, payload)
           .pipe(takeUntil(this.observableSubscription$))
           .subscribe((response: any) => {
             if (response.status == 200) {
               this.toastr.success(response.message, 'Success');
               localStorage.removeItem("plan");
               localStorage.removeItem("tokenFetch");
               localStorage.removeItem("companyname");
               this.router.navigate([`/`]);
             }
           });
        } else {
        const payload = {
          attorneyCreateDTO: {
            relationShip: {
              id: null
             },
            relatedCompany: null,
            company: {
              id: null,
              companyLogo: "",
              companyName: companyFirmData.company.companyName,
              feiNo: companyFirmData.company.feiNo,
              establishedDate: companyFirmData.company.establishedDate,
              incorporationLoc: {
                countryCode: companyFirmData.company.incorporationLoc
              },
              companyType: {id: 39},
              emailContacts: [
                {
                  type: {
                    id: 34
                  },
                  email: companyFirmData.company.emailContact.email
                }
              ],
              phoneContacts: [
                {
                  id: null,
                  countryCode: {countryCode: "USA"},
                  phoneNo: "123456789",
                  type: { id: 30}
                },
              ],
              address: [
              {
                id: null,
                addressLine1: companyFirmData.company.address1,
                city: companyFirmData.company.city,
                countryCode: {
                  countryCode: companyFirmData.company.countryCodeAdd
                },
                postCode: companyFirmData.company.postCode,
                stateProvinceCode: companyFirmData.company.stateProvinceCode,
                type: {
                  id: 3,
                  code: "REGS"
                  }
              }
            ],
              employeeCount: companyFirmData.company.employeeCount,
              grossAnnualIncome: companyFirmData.company.grossAnnualIncome,
              classification: "",
              netAnnualIncome: companyFirmData.company.netAnnualIncome,
              mgrExecUSCount: companyFirmData.company.mgrExecUSCount,
              mgrExecNonUSCount:companyFirmData.company.mgrExecNonUSCount,
              dotCode: "",
              naicsCode: companyFirmData.company.naicsCode,
              businessType: [
                {
                  otherBusTypeName: null,
                  typeId: {id: 37}
                }
              ]
              }
          },
          attorneyUserEmployeeDTO,
           companyCreateDTO: {
             relationShip: {id: 46},
             relatedCompany: null,
             company: {
               id: null,
               companyLogo: "",
               companyName: companyData.company.companyName,
               feiNo: companyData.company.feiNo,
               incorporationLoc: {
                 countryCode: companyData.company.incorporationLoc.countryCode
               },
               companyType: {id: 38},
               emailContacts: [
                 {
                   type: {id: 34},
                   email: companyData.company.emailContact.email
                 }
               ],
               establishedDate: moment(companyData.company.establishedDate).format('MM-DD-YYYY'),
               phoneContacts: [
                 {
                   id: null,
                   countryCode: {
                     countryCode: companyData.company.mobileContacts.countryCode
                   },
                   phoneNo: companyData.company.mobileContacts.phoneNo,
                   type: { id: 30 }
                 },
               ],
               address: [
                 {
                   id: null,
                   addressLine1: companyData.company.address1,
                   city: companyData.company.city,
                   countryCode: {countryCode: companyData.company.countryCodeAdd},
                   postCode: companyData.company.postCode,
                   stateProvinceCode: companyData.company.stateProvinceCode,
                   type:
                   {
                     id: 3,
                     code: "REGS"
                   }
                 },
                 ],
               employeeCount: companyData.company.employeeCount,
               grossAnnualIncome: companyData.company.grossAnnualIncome,
               netAnnualIncome: companyData.company.netAnnualIncome,
               classification: "",
               mgrExecUSCount: "",
               mgrExecNonUSCount: "",
               naicsCode: companyData.company.naicsCode,
               dotCode: "",
               businessType:
               [
                 {
                   otherBusTypeName: companyData.company.businessType.name,
                   typeId: {id: 37}
                 },
               ]
             }
           },
           listOfInvitedBeneficiarys,
           petitionerUserEmployeeDTO,
           planStartDate: this.finalDate
     };
        console.log('payload :--' + JSON.stringify(payload));
        this.freeTrialService.postReviewSummaryPetitionerFlow(this.getLink, payload)
         .pipe(takeUntil(this.observableSubscription$))
         .subscribe((response: any) => {
           if (response.status == 200) {
             this.toastr.success(response.message, 'Success');
             localStorage.removeItem("plan");
             localStorage.removeItem("tokenFetch");
             localStorage.removeItem("companyname");
             this.router.navigate([`/`]);
           }
         });
        }
    }
  }

  editSection(tabId){
    this.notify.emit(tabId);
  }

  checkboxClick(event) {
    if (event.checked) {
      this.agree = false;
    }
    else {
      this.agree = true;
    }
  }

  editSectionBeneInvite(tabId) {
    if (localStorage.getItem("plan") == "Petitioner Plan") {
      this.notify.emit(tabId);
    } else {
      this.notify.emit(tabId + 1);
    }
  }

}
